// Should stay in sync with observationReportDocumentsStatus.mjs
export default {
  PENDING_REVIEW: 0,
  ACCEPTED: 1,
  RETURNED: 2
};
